define([
    './services/VinLookupService',
    './services/AvailabilityService',
    './services/AddressLookupService',
    './services/BaslerTypelistMappingService',
    'portalConfig',
    'edge/platform/base/module'
], (VinLookupService, AvailabilityService, AddressLookupService, BaslerTypelistMappingService) => {
    return angular.module('edge.policyjob.app', ['portal.config', 'edge.platform.base'])
        .config(['EventHubProvider', (EventHubProvider) => {
            EventHubProvider.registerTransformer({
                source: {
                    category: 'tracking',
                    eventName: 'serverCall'
                },
                target: {
                    category: 'journey',
                    eventName: 'policyChange'
                },
                transformer(payload, send) {
                    if (payload
                        && payload.success
                        && payload.path
                        && payload.method === 'bind'
                        && payload.path === 'policychange/policychange') {
                        const policyChange = payload.response.policyChange;
                        if (policyChange.status === 'Bound') {
                            send({
                                accountNumber: policyChange.accountNumber,
                                policyNumber: policyChange.policyNumber,
                                productCode: policyChange.productCode,
                                effectiveDate: policyChange.effectiveDate,
                                jobID: policyChange.jobID,
                                history: policyChange.history
                            });
                        }
                    }
                }
            });
            EventHubProvider.registerTransformer({
                source: {
                    category: 'wizard',
                    eventName: '*'
                },
                target: {
                    category: 'tracking',
                    eventName: 'pageView'
                },
                transformer(payload, send) {
                    if (payload
                        && ((payload.url === '/endorsement') || (payload.url === '/tiledEndorsement'))
                        && payload.model
                        && payload.model.policyChange
                        && payload.model.policyChange.productCode
                        && payload.toState) {
                        const url = payload.url;
                        const wizardStepName = payload.toState.name;
                        const productCode = payload.model.policyChange.productCode;
                        send({path: `${url}/${productCode}/${wizardStepName}`});
                    }
                }
            });
        }])

        .factory('VinLookupService', VinLookupService)
        .factory('AvailabilityService', AvailabilityService)
        .factory('AddressLookupService', AddressLookupService)
        .factory('BaslerTypelistMappingService', BaslerTypelistMappingService)
});



// WEBPACK FOOTER //
// ../common/js/src/edge/policyjob/app.js